import { put } from "redux-saga/effects";
import request from "../../utils/request";
import * as actions from "../actions/documentDetailAction";
import { call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { SUPPLIER_PATH } from "../../config/path";

export function* getDocumentDetail(action) {
  const requestURL = `${SUPPLIER_PATH}/get-doc-attrs?docId=${action.payload.docId
    }&catName=${action.payload.catName === "Check-ACH"
      ? "SUPP WEB BSCC AP Payment"
      : "SUPP WEB BSCC AP Merchandise"
    }`;
  const requestAttrs = {
    method: "GET"
  };
  try {
    const response = yield call(request, requestURL, requestAttrs);
    let data = response.rows[0].categories;
    yield put(actions.documentDetailSuccess(data ? data : []));
  } catch (err) {
    toast.error("Failed to load Document details, please reload.", { autoClose: false });
  }
}
